import './main.js';
import './sign-in.js';
import './client/client.js';
import './client/clientNew.js';
import './client/clientShow.js';
import './clients_group/clientGroup.js';
import './clients_group/clientGroupNew.js';
import './clients_group/clientGroupShow.js';
import './project/project.js';
import './project/projectIndex.js';
import './project/projectNew.js';
import './project/projectShow.js';
import './employee/employee.js';
import './employee/employeeNew.js';
import './employee/employeeShow.js';
import './user/user.js';
import './user/userNew.js';
import './user/userShow.js';
import './invoice/invoiceNew.js';
import './scope_change/scopeChangeNew.js';
import './scope_change/scopeChangeInbox.js';
import './scope_change/scopeChangeShow.js';
import './invoice/invoiceShow.js';
import './productCatalog/productCatalog.js';
import './productCatalog/productCatalogNew.js';
import './productCatalog/productCatalogShow.js';
import './prospect/prospect.js';
import './prospect/prospectNew.js';
import './prospect/prospectShow.js';
import './quotation/quotation.js';
import './quotation/quotationNew.js';
import './quotation/quotationShow.js';
import './app_licenses/app_license.js';
import './app_licenses/app_licensesNew.js';
import './app_licenses/app_licensesShow.js';
import './activities/activities.js';
import './activities/showGoogleCalendar.js';
import './workspace/workspaces.js';
import './workspace/workspacesNew.js';
import './workspace/workspacesShow.js';
import './holydays/holydays.js';
import './holydays/holydaysNew.js';
import './reporting/reporting_activities.js';
import '../changeLogSia.js';
import './assignments/assignment.js';
import './assignments/assignmentNew.js';
import './assignments/assignmentShow.js';


export default 'thothApp.controllers';